export default __webpack_public_path__ + "static/InsightFeatureThree-2ed89ac3717619d5d2874ec92f7cb86c.webp";